// CakeDisclaimerSelector.jsx
import React, { useEffect, useState } from "react";
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Chip,
  OutlinedInput,
  Box,
  CircularProgress,
} from "@mui/material";
import api from "../../../services/api";

const CakeDisclaimerSelector = ({ selectedDisclaimerIds, onChange }) => {
  const [disclaimers, setDisclaimers] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchDisclaimers = async () => {
      setLoading(true);
      try {
        const res = await api.get("/admin/disclaimers");
        setDisclaimers(res.data);
      } catch (err) {
        console.error("Failed to fetch disclaimers", err);
      } finally {
        setLoading(false);
      }
    };
    fetchDisclaimers();
  }, []);

  return (
    <FormControl fullWidth margin="dense">
      <InputLabel>Disclaimers</InputLabel>
      <Select
        multiple
        value={selectedDisclaimerIds}
        onChange={onChange}
        input={<OutlinedInput label="Disclaimers" />}
        renderValue={(selected) => (
          <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
            {selected.map((id) => {
              const found = disclaimers.find((d) => d._id === id);
              return <Chip key={id} label={found?.displayName || id} />;
            })}
          </Box>
        )}>
        {loading ? (
          <MenuItem disabled>
            <CircularProgress size={20} /> Loading...
          </MenuItem>
        ) : (
          disclaimers.map((d) => (
            <MenuItem key={d._id} value={d._id}>
              {d.displayName}
            </MenuItem>
          ))
        )}
      </Select>
    </FormControl>
  );
};

export default CakeDisclaimerSelector;
